export default function GooFortIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="4" y="4" width="56" height="56" rx="10" fill="#7cc95a" />
      <rect x="8" y="8" width="10" height="10" rx="2" fill="#a7adb8" stroke="#4f5562" strokeWidth="2" />
      <rect x="18" y="8" width="10" height="10" rx="2" fill="#a7adb8" stroke="#4f5562" strokeWidth="2" />
      <rect x="8" y="18" width="10" height="10" rx="2" fill="#a7adb8" stroke="#4f5562" strokeWidth="2" />
      <rect x="22" y="22" width="22" height="22" rx="5" fill="#f3c94a" stroke="#94680f" strokeWidth="3" />
      <circle cx="33" cy="33" r="6" fill="#3a2a18" />
      <circle cx="31" cy="32" r="3" fill="#ffcf33" />
      <circle cx="35" cy="34" r="3" fill="#ffcf33" />
      <path d="M46 40 C40 40 38 48 40 54 L58 54 C60 48 56 40 50 40 Z" fill="#7be35a" stroke="#26213a" strokeWidth="2.5" />
      <circle cx="45.5" cy="47" r="3" fill="#fff" stroke="#26213a" strokeWidth="1.2" />
      <circle cx="52.5" cy="47" r="3" fill="#fff" stroke="#26213a" strokeWidth="1.2" />
      <circle cx="46" cy="47.5" r="1.4" fill="#1b1530" />
      <circle cx="53" cy="47.5" r="1.4" fill="#1b1530" />
      <path d="M40 18 l10 -8 M44 20 l10 -8" stroke="#7a4a22" strokeWidth="3" strokeLinecap="round" />
      <path d="M49 6 q8 2 6 10" stroke="#4f5562" strokeWidth="4" fill="none" strokeLinecap="round" />
    </svg>
  );
}
